import { search } from '@/core/filters/filters'
import { resizeTableHeight } from '@/core/support_gui_components/table/table'
import { resetMulticheckbox } from '@/core/input_controls/multicheckbox/multicheckbox'
import { loadConfig } from '@/core/shared'

export function clearFilters (itemStructure, table) {
	$('#search-controls').find('input:not(.bg-editor)').val('')
	$('#search-controls').find('textarea').val('')
	$('#search-controls').find('select').val('any')
	$('#search-controls').find('.multicheckbox-filter').each(function () {
		resetMulticheckbox(this)
	})
	$('#search_phrase').find('input').val('');
	$('#status').find('button').removeClass('selected')
	search(itemStructure, table)
}

export function initFilterForm (itemStructure, table) {
	$('#search-clear').bind('click', function () {
		clearFilters(itemStructure, table)
	})
	$('#search').bind('click', function () {
		search(itemStructure, table)
	})
	$('#status').on('click', '.status-filter-element button', function () {
		if (!$(this).hasClass('selected')) {
			var $selected = $(this).closest('.status-filter-element').find('button.selected').first()
			if ($selected[0]) $selected.toggleClass('selected')
		}
		$(this).toggleClass('selected')
	})
	$('.page').on('mcb-list-show', '.multicheckbox-filter .mcb-item-list', function (e) {
		var $mcbFilter = $(e.target).closest('.multicheckbox-filter')
		if ($mcbFilter[0]) {
			var $valList = $mcbFilter.find('.value-list').first()
			var $searchControls = $mcbFilter.closest('#search-controls')
			$searchControls.scrollTop($searchControls.scrollTop() + $mcbFilter.position().top + ($valList[0] ? $valList.height() : 0))
		}
	})
	$('.page').on('DOMSubtreeModified', '.multicheckbox-filter .value-list', function () {
		resizeTableHeight()
	})
	setFilterState(table)
	bindSwitchMultipleFilterButton()
}

function setFilterState () {
	var keyFilterState = table.id + '.filtersState'
	var filterData = JSON.parse(localStorage.getItem(keyFilterState))
	if (_.isEmpty(filterData)) {
		filterData = loadConfig(keyFilterState)
	}
	table.setFiltersDataState(filterData)
}

function bindSwitchMultipleFilterButton () {
	$('.button_multiple-switcher').click(function () {
		if ($(this).parent().find('textarea').is('textarea')) {
			switchMultipleFilterToSingle(this)
		} else if ($(this).parent().find('input').is('input')) {
			switchSingleFilterToMultiple(this)
		}

		resizeTableHeight()
	})
}

export function switchSingleFilterToMultiple (target) {
	var select = $(target).parent().find('select')

	var input = $(target).siblings('input')
	input.replaceWith($(document.createElement('textarea')).addClass('textarea').val(input.val()))
	if (select.is('select')) {
		select.removeClass('select-split').addClass('select')
	}
	$(target).parent().find('.button_reset').addClass('filter-textarea-button-reset')
}

function switchMultipleFilterToSingle (target) {
	var select = $(target).parent().find('select')

	var inputClass = 'textInput'
	if (select.is('select')) {
		select.removeClass('select').addClass('select-split')
		inputClass = 'textInput-split'
	}
	var textarea = $(target).siblings('textarea')
	textarea.replaceWith($(document.createElement('input')).addClass(inputClass).val(textarea.val().split('\n')[0]))
	$(target).parent().find('.button_reset').removeClass('filter-textarea-button-reset');
}
